import BaseApi from "@/core/HttpResources/BaseApi";
import IndicatorGroup from "@/models/indicator/indicatorGroup.model";

export default class IndicatorGroupService {
  baseApiPublish = new BaseApi("IndicatorGroups");
 
  
  async saveGroup(
    baseGroupId: number,
    group: IndicatorGroup
    ,
  ): Promise<IndicatorGroup> {
    return new Promise<IndicatorGroup>((resolve, reject) =>
      this.baseApiPublish.request(
        "POST",
        "Guardar/" + baseGroupId,
        group,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
   
    
 
}
